import { type ReactNode, useEffect } from 'react';

import { Spinner } from '@/components/ui/spinner';
import { useChurchStore } from '@/stores/church-store';

/** Loads memberships once for routes that sit outside `RequireChurch`. */
export const ChurchBootstrap = ({ children }: { children: ReactNode }) => {
  const status = useChurchStore((state) => state.status);
  const restore = useChurchStore((state) => state.restore);

  useEffect(() => {
    if (status === 'unknown') void restore();
  }, [status, restore]);

  if (status === 'unknown') {
    return (
      <div className="flex min-h-screen items-center justify-center" role="status">
        <Spinner className="size-8 text-brand" />
      </div>
    );
  }

  return <>{children}</>;
};
